import { FC } from "react";

import { Tag } from "capitalrx-components-2.0/lib/general";

import { isRenewalWindowOpen } from "@/utils";

interface PACaseRenewalTagProps {
  expirationDate?: string;
  renewalWindowDate?: string;
  hasRenewalCode?: boolean;
}

export const PACaseRenewalTag: FC<PACaseRenewalTagProps> = ({
  expirationDate,
  renewalWindowDate,
  hasRenewalCode = false,
}) => {
  if (hasRenewalCode) {
    return <Tag type="info" testId="test__pa_case_renewal_requested_tag">Renewal Requested</Tag>;
  }

  if (!isRenewalWindowOpen(renewalWindowDate, expirationDate)) {
    return null;
  }

  return <Tag type="system-high-contrast" testId="test__pa_case_renewal_available_tag">Renewal Available</Tag>;
};

export default PACaseRenewalTag;
